import React from "react";
import { Link } from "react-router-dom";
import "../pages_css/About.css";
import profileImg from "../assets/images/about/profile.png?w=900&format=webp";
import codingImg from "../assets/images/about/codingImg.png";
import roboticsImg from "../assets/images/about/roboticsImg.png";
import tattooingImg from "../assets/images/about/tattooingImg.png";
import drawingImg from "../assets/images/about/drawingImg.png";
import ImageOrbitCarousel from "../components/about_beyond_section";
import SkillsCarousel from "../components/SkillsCarousel";

const highlightCards = [
  { id: 2, image: roboticsImg,  label: "Robotics",  w: 98,  h: 103, path: "/about/robotics" },
  { id: 1, image: codingImg,    label: "Coding",    w: 116, h: 103, path: "/about/coding" },
  { id: 3, image: tattooingImg, label: "Tattooing", w: 118, h: 103, path: "/about/tattooing" },
  { id: 4, image: drawingImg,   label: "Drawing",   w: 120, h: 106, path: "/about/drawing" },
];

const skillGroups = [
  {
    title: "Languages",
    items: ["HTML", "CSS", "JavaScript", "TypeScript", "Python", "PHP", "C++", "SQL"],
  },
  {
    title: "Frameworks & Tools",
    items: ["React", "Node.js", "Next.js", "Bootstrap", "WordPress", "Git / GitHub", "MySQL", "Figma", "VS Code"],
  },
  {
    title: "Platforms",
    items: ["Linux", "Windows", "iOS"],
  },
  {
    title: "Creative Tools",
    items: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Adobe After Effects", "Adobe Premiere Pro", "Canva"],
  },
  {
    title: "Soft Skills",
    items: ["Adaptability", "Leadership", "Communication", "Teamwork", "Problem Solving"],
  },
  {
    title: "AI",
    items: ["Claude", "ChatGPT", "Gemini", "Groq", "Codex"],
  },
];

function About() {
  return (
    <section className="about-page">

      {/* Back Button */}
      <Link to="/" className="back-home">
        ← Back to home
      </Link>

      {/* Header */}
      <header className="about-header">
        <h1>ABOUT</h1>
        <span className="underline"></span>
      </header>

      {/* HERO SECTION */}
      <div className="about-hero">

        {/* LEFT TEXT */}
        <div className="about-text">
          <h2>HI, I&apos;m Vaibhav Kapoor (Vabz)</h2>
          <span className="name-underline"></span>

          <div className="about-subheading">
            <p>FRONT-END DEVELOPER</p>
            <p>FULL STACK DEVELOPER</p>
          </div>

          <p className="about-description">
            I am a creator who blends technology and art. From coding, web
            development and robotics to visual storytelling and tattoo design I
            enjoy building digital experiences that combine structure,
            creativity, and purpose.
          </p>

          <blockquote className="about-quote">
            <p>Magic is in every moment</p>
            <p>You just need to believe</p>
          </blockquote>
        </div>

        {/* RIGHT IMAGE */}
        <div className="about-image-wrap">
          <img src={profileImg} alt="Vaibhav portrait" width="400" height="300" />
        </div>

      </div>

      {/* HIGHLIGHT INTRO */}
      <div className="highlight-intro">
        <span className="highlight-intro__label">Passions &amp; Disciplines</span>
        <h2>Crafting Across <span>Disciplines</span></h2>
        <p>From code to creativity, select a discipline to explore my journey.</p>
      </div>

      {/* HIGHLIGHT CARDS */}
      <section className="highlight-grid">
        {highlightCards.map((card, index) => (
          <Link
            to={card.path}
            className="highlight-card"
            key={card.id}
            style={{ "--card-delay": `${index * 120}ms` }}
          >
            <img
              className="highlight-image"
              src={card.image}
              alt={card.label}
              width={card.w}
              height={card.h}
            />
            <p>{card.label}</p>
          </Link>
        ))}
      </section>

      {/* PANELS */}
      <section className="about-panels">

        {/* JOURNEY */}
        <div className="about-panel journey-panel">
          <h3>MY JOURNEY</h3>
          <span className="panel-underline journey"></span>

          <div className="journey-timeline">

            <div className="journey-step">
              <div className="journey-step__left">
                <span className="journey-step__number">01</span>
                <span className="journey-step__line"></span>
              </div>
              <div className="journey-step__content">
                <h4>Curiosity &amp; Systems</h4>
                <p>My journey started with curiosity about how things work. Robotics introduced me to structured thinking, while coding let me transform ideas into real digital experiences.</p>
              </div>
            </div>

            <div className="journey-step">
              <div className="journey-step__left">
                <span className="journey-step__number">02</span>
                <span className="journey-step__line"></span>
              </div>
              <div className="journey-step__content">
                <h4>Art &amp; Visual Craft</h4>
                <p>Tattooing and drawing taught me patience, precision, and visual storytelling shaping the way I design by balancing creativity with technical execution.</p>
              </div>
            </div>

            <div className="journey-step journey-step--last">
              <div className="journey-step__left">
                <span className="journey-step__number">03</span>
              </div>
              <div className="journey-step__content">
                <h4>Today</h4>
                <p>I focus on creating digital experiences that feel intentional, functional, and visually meaningful blending every discipline into purposeful work.</p>
              </div>
            </div>

          </div>
        </div>

      </section>

      {/* SKILLS CAROUSEL */}
      <section className="about-skills-section">
        <SkillsCarousel />
      </section>

      {/* CAROUSEL */}
      <section className="about-carousel">
        <ImageOrbitCarousel />
      </section>

    </section>
  );
}

export default About;